import { createFileRoute } from '@tanstack/react-router'
import { IncidentEditRoute } from '@/features/incidents/v2/incident-edit-route'

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/$incidentId/edit'
)({
  component: IncidentEditRoute,
})
